import { render, staticRenderFns } from "./PackingLabel.vue?vue&type=template&id=815c6a6e&scoped=true&"
import script from "./PackingLabel.vue?vue&type=script&lang=js&"
export * from "./PackingLabel.vue?vue&type=script&lang=js&"
import style0 from "./PackingLabel.vue?vue&type=style&index=0&id=815c6a6e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "815c6a6e",
  null
  
)

export default component.exports